import * as Y from 'yjs'

export function arrayFind<T>(array: Y.Array<T>, predicate: (item: T) => boolean): T | undefined {
    for (const item of array) {
        if (predicate(item)) return item
    }
}
